var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("normalDialog", {
    attrs: {
      dialog: _vm.show,
      width: "1000",
      maxWidth: "1000",
      scrollable: "",
      title: _vm.$t("label_essweb_RosterFormRecord_form_dialog_editShiftTitle"),
    },
    on: { close: _vm.closePorpertyDialog },
    scopedSlots: _vm._u([
      {
        key: "content",
        fn: function () {
          return [
            _c("Tabler", {
              attrs: {
                headers: _vm.headers,
                showFooter: false,
                height: 500,
                selectKey: "isSelectable",
                itemKey: "shift_uuid",
                defaultSelect: _vm.selected,
                items: _vm.desserts,
                showSelect: _vm.showSelect,
              },
              on: {
                select: function (sel) {
                  return (_vm.selected = sel)
                },
              },
              scopedSlots: _vm._u([
                {
                  key: "item.color",
                  fn: function (ref) {
                    var item = ref.item
                    return [
                      _c(
                        "div",
                        { staticStyle: { "max-width": "20px" } },
                        [
                          _c("svg-icon", {
                            attrs: {
                              size: "24",
                              fill: item.color_code,
                              iconClass: "LabeledColour",
                            },
                          }),
                        ],
                        1
                      ),
                    ]
                  },
                },
                {
                  key: "item.name",
                  fn: function (ref) {
                    var item = ref.item
                    return [
                      _c("div", { staticClass: "text--primary table-title" }, [
                        _vm._v(
                          " " +
                            _vm._s(_vm.$getCommonLangValue(item.shift_name)) +
                            " "
                        ),
                      ]),
                      _c(
                        "div",
                        { staticClass: "text--secondary table-subtitle ma-0" },
                        [
                          _vm._v(
                            " " +
                              _vm._s(
                                _vm.$getCommonLangValue(item.shift_description)
                              ) +
                              " "
                          ),
                        ]
                      ),
                    ]
                  },
                },
                {
                  key: "item.abbr",
                  fn: function (ref) {
                    var item = ref.item
                    return [_vm._v(" " + _vm._s(item.shift_abbr) + " ")]
                  },
                },
                {
                  key: "item.startTime",
                  fn: function (ref) {
                    var item = ref.item
                    return [
                      _vm._v(_vm._s(_vm.$timeMachine(item.start_utc_time))),
                    ]
                  },
                },
                {
                  key: "item.endTime",
                  fn: function (ref) {
                    var item = ref.item
                    return [_vm._v(_vm._s(_vm.$timeMachine(item.end_utc_time)))]
                  },
                },
                {
                  key: "item.total",
                  fn: function (ref) {
                    var item = ref.item
                    return [_vm._v(_vm._s(item.total_working_minutes))]
                  },
                },
              ]),
            }),
          ]
        },
        proxy: true,
      },
      {
        key: "actions",
        fn: function () {
          return [
            _c("CardActions", {
              attrs: { saveBtn: "" },
              on: { save: _vm.toSave, cancel: _vm.closePorpertyDialog },
            }),
          ]
        },
        proxy: true,
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }